<!--
  - Copyright (c) 2019 LNBIG.com
  - All rights reserved.
  -->

<template>
  <v-row
    justify="center"
    align="center"
  >
    <v-col class="text-center">
      <p>Info will be later... ;-)</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
}
</script>
